module.exports = __webpack_public_path__ + "img/8.9b2f860a.webp";